import GuestGlimpse from './guest_glimpse'
import { connect } from 'react-redux'
import { destroy } from 'redux-form'

const mapDispatchToProps = dispatch => {
  return {
    onUnmount() {
      // This is here (and not in the route's onLeave) because of lifecycle cosiderations. The onLeave callback
      // is called before everything is unmounted, so if we clear the form (and other things)
      // when before the send flow's components are unmounted, they will do unneccsary update, or worse -
      /// they will do updates with null (or undefined) values.

      dispatch(destroy('send')) // NOTE: still removing 'send' form, because send components & form are used with /guest
    },
  }
}

export default connect(
  undefined,
  mapDispatchToProps
)(GuestGlimpse)
